import { useGeneralStore } from '@/stores/general';
import type { CartItem, EventItem, vat } from '@/types';

export const vatItem: vat = {
  cardfee: 25,
  ticketprice: 25,
  shippingfee: 25,
  ticketfee: 25,
};

export function eventToCartItem(event: EventItem): CartItem {
  const generalStore = useGeneralStore();
  const venues = generalStore.venues();
  const venueObj = venues.find(v => v.id === event.venue);
  const venueName = venueObj ? venueObj.name : '';


  return {
    id: event.id,
    name: event.info1,
    currency: event.currency || 'DKK',
    vat: vatItem, // TODO make dynamic
    giftcard_allowed: true, // TODO make dynamic
    localizations: event.localizations || {},
    eventtime: event.eventtime || 0,
    eventtime_gmt_offset: event.eventtime_gmt_offset || 0,
    eventtime_override: event.eventtime_override || null,
    venueName,
    photo1_id: event.photo || '',
    tickets: [],
    upsaleTickets: [],
  };
}
